import { Settings, X } from 'lucide-react'

export default function SettingsIcon() {
  return <Settings size={24} strokeWidth={2} />
}

export function SettingsIconLight() {
  return (
    <svg
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      data-testid='settings-icon-light'
    >
      <path
        d='M6.5663 4.34448L5.98025 4.20923C5.48466 4.09487 4.96511 4.24387 4.60547 4.60352C4.24582 4.96316 4.09682 5.48271 4.21119 5.9783L4.34643 6.56435C4.50232 7.23985 4.22377 7.94131 3.64695 8.32586L2.93434 8.80093C2.53365 9.06806 2.29297 9.51778 2.29297 9.99935C2.29297 10.4809 2.53365 10.9306 2.93434 11.1978L3.64695 11.6728C4.22377 12.0574 4.50232 12.7588 4.34643 13.4344L4.21119 14.0204C4.09682 14.516 4.24583 15.0355 4.60547 15.3952C4.96511 15.7548 5.48466 15.9038 5.98025 15.7895L6.5663 15.6542C7.24181 15.4983 7.94327 15.7769 8.32782 16.3537L8.80289 17.0663C9.07002 17.467 9.51973 17.7077 10.0013 17.7077C10.4829 17.7077 10.9326 17.467 11.1997 17.0663L11.6748 16.3537C12.0593 15.7769 12.7608 15.4983 13.4363 15.6542L14.0224 15.7895C14.5179 15.9038 15.0375 15.7548 15.3971 15.3952C15.7568 15.0355 15.9058 14.516 15.7914 14.0204L15.6562 13.4343C15.5003 12.7588 15.7788 12.0574 16.3557 11.6728L17.0683 11.1978C17.469 10.9306 17.7096 10.4809 17.7096 9.99935C17.7096 9.51778 17.469 9.06806 17.0683 8.80093L16.3557 8.32586C15.7788 7.94131 15.5003 7.23985 15.6562 6.56435L15.7914 5.97829C15.9058 5.48271 15.7568 4.96316 15.3971 4.60352C15.0375 4.24387 14.5179 4.09487 14.0224 4.20923L13.4363 4.34448C12.7608 4.50036 12.0593 4.22182 11.6748 3.64499L11.1997 2.93239C10.9326 2.53169 10.4829 2.29102 10.0013 2.29102C9.51973 2.29102 9.07002 2.53169 8.80289 2.93239L8.32782 3.64499C7.94327 4.22182 7.24181 4.50036 6.5663 4.34448Z'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinejoin='round'
      />
      <path
        d='M12.293 9.99935C12.293 11.265 11.267 12.291 10.0013 12.291C8.73565 12.291 7.70964 11.265 7.70964 9.99935C7.70964 8.7337 8.73565 7.70768 10.0013 7.70768C11.267 7.70768 12.293 8.7337 12.293 9.99935Z'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export function CloseIcon() {
  return <X size={22} strokeWidth={2} />
}
